import { isValidElement } from 'react';
import { parseCategories } from "../utils/parseCategories.js";
import { parseChild } from "../utils/parseChild.js";
export const useParsedElements = (options, filter, favorites, nullable, searchString) => {
  let parsedElements = (options.props.children ?? []).map((child, index) => {
    return /*#__PURE__*/isValidElement(child) && parseChild(child, filter, searchString, favorites, index);
  }).filter(Boolean);
  const {
    hasCategories,
    elements
  } = parseCategories(parsedElements);
  parsedElements = [{
    id: 'UNDEFINED',
    label: '—',
    type: 'OPTION',
    filtered: !nullable || !!searchString,
    disabled: !nullable
  }, ...elements];
  let selectionCandidate = parsedElements.findIndex(element => element.type === 'OPTION' && !element.filtered && !element.disabled);
  if (selectionCandidate === -1) {
    selectionCandidate = undefined;
  }
  return {
    parsedElements,
    selectionCandidate,
    hasCategories
  };
};